//React
import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as partnerAction from '../action/partnerAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';

//Icon

import CloseIcon from '@material-ui/icons/Close';



class Comp extends React.Component {

  _answerAddSubmit(answerOpen) {
    this.props.partnerQaQuestionAnswerAdd(
      this.props.answerAddQaId,
      answerOpen,
      this.props.answerAddText
    );
    this.props.close();
  }

	render() {
		return (
        <Dialog
          open={this.props.open}
          onClose={ () => this.props.close() }
          style={{maxWidth:'600px', margin:'auto'}}
        >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'space-between',
          }}
        >
          <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
            Q&Aの回答
          </div>
          <IconButton
            onClick={ () => this.props.close() }
          >
            <CloseIcon/>
          </IconButton>
        </div>
        <div style={{margin:'10px'}}>
          「{ this.props.answerAddText }」
        </div>
        <div style={{margin:'10px'}}>
          <div>
            回答を自分のプロフィールにも掲載しますか？
          </div>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'space-between',
            }}
          >
            <div style={{flex:1, margin:'5px'}}>
              <Button
                variant="contained"
                color="primary"
                style={{fontSize:'1em',width:'100%'}}
                onClick={ () => this.props.apply(1) }

              >
                掲載する
              </Button>
            </div>
            <div style={{flex:1, margin:'5px'}}>
              <Button
                variant="contained"
                color="secondary"
                style={{fontSize:'1em',width:'100%'}}
                onClick={ () => this.props.apply(0) }
              >
                掲載しない
              </Button>
            </div>
          </div>
        </div>

      </Dialog>

		)
	}
}



const mapStateToProps = (state) => {
	return {

	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...partnerAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
